import { injectIntl } from "react-intl";
import { Link } from "react-router-dom";
import { ButtonGroup, Clue, url, intlShape } from "lcm-iot-commons";

type OwnProps = {
  intl: intlShape;
};

const defaultProps: Partial<OwnProps> = {};

type Props = OwnProps & typeof defaultProps;

export function NoProducts({ intl }: Props) {
  return (
    // @ts-expect-error TS(2322) FIXME: Type '{ children: Element; id: string; title: stri... Remove this comment to see the full error message
    <Clue
      id="no-products-found"
      title={intl.formatMessage({ id: "products.no_products_found" })}
      details={intl.formatMessage({
        id: "products.no_products_found.ask_create",
      })}
      className="notification"
      highlighted
    >
      <ButtonGroup>
        <Link className="btn btn-primary" to={url("/products/create")}>
          {intl.formatMessage({ id: "products.create_product" })}
        </Link>
      </ButtonGroup>
    </Clue>
  );
}

NoProducts.defaultProps = defaultProps;

export default injectIntl(NoProducts);
